import React, { FC } from 'react';
import { CustomerTiles } from 'src/components/CustomerTiles';
import { PageHeading } from 'src/components/page-heading/page-heading';
import { IOrderSimulation } from 'src/graphql/types';
import styled from 'styled-components';
import { White, White2 } from '../../styles/colours';
import { ProductCard } from './product-card';
import { OrderSimulationSearchControls } from './search-controls';
import { OrderSimulationTable } from './table/table';

const StyledLowerSection = styled.section`
  padding: 4.5rem 7.5rem 4.5rem 7.5rem;
  background-color: ${White2};
`;

const StyledSearch = styled.div`
  padding: 1rem 0rem 0rem 0rem;
`;

const StyledTopSection = styled.div`
  background-color: ${White};
  padding: 0rem 0rem 3rem 7.5rem;
`;

const StyledHeadContainer = styled.div`
  padding-top: 2rem;
`;

const StyledTileContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const OrderSimulationBody: FC<{
  orderSimulation: IOrderSimulation;
  quantity: string;
}> = ({ orderSimulation, quantity }) => {
  return (
    <>
      <StyledTopSection>
        <StyledHeadContainer>
          <PageHeading>Order simulation</PageHeading>
        </StyledHeadContainer>
        <StyledTileContainer>
          <CustomerTiles
            soldTo={orderSimulation.soldTo}
            shipTo={orderSimulation.shipTo}
            showRemoveLink={false}
          />
          <ProductCard orderSimulation={orderSimulation} quantity={quantity} />
        </StyledTileContainer>
      </StyledTopSection>
      <StyledLowerSection>
        <StyledSearch>
          <OrderSimulationSearchControls
            soldToId={orderSimulation.soldTo.id}
            shipToId={orderSimulation.shipTo.id}
            productId={orderSimulation.product.id}
            quantity={quantity}
            salesOrg={orderSimulation.product.salesOrg}
          />
        </StyledSearch>
        <OrderSimulationTable orderSimulation={orderSimulation} />
      </StyledLowerSection>
    </>
  );
};
